export default "__VITE_ASSET__54ca6032__"